import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function GalleryPlaceholder() {
  return (
    <Component>
      <BigSlider>
        <BigSliderSlide />
      </BigSlider>
      <BottomSlider>
        <BottomSlideWrapper>
          <BottomSlide />
        </BottomSlideWrapper>
        <BottomSlideWrapper>
          <BottomSlide />
        </BottomSlideWrapper>
        <BottomSlideWrapper>
          <BottomSlide />
        </BottomSlideWrapper>
        <BottomSlideWrapper>
          <BottomSlide />
        </BottomSlideWrapper>
        <BottomSlideWrapper>
          <BottomSlide />
        </BottomSlideWrapper>
      </BottomSlider>
    </Component>
  );
}

export default GalleryPlaceholder;

const Component = styled.div``;

const BigSlider = styled.div`
  position: relative;
  padding-top: 55%;
  border-radius: 10px;
`;

const BigSliderSlide = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  ${placeholderAnimationCss}
`;

const BottomSlider = styled.div`
  margin-top: 20px;
  display: flex;

  ${media.mobile(css`
    display: none;
  `)}
`;

const BottomSlideWrapper = styled.div`
  flex: 20%;
  position: relative;
  padding-top: 11%;
  border-radius: 8px;

  &:not(:last-child) {
    margin-right: 5px;
  }
`;

const BottomSlide = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  ${placeholderAnimationCss}
`;
